module.exports = __webpack_public_path__ + "img/closed_dark.98b79a88.svg";